import { createReducer } from 'store/createReducer';
import { IMainMenu } from 'models/IMainMenu';

import {
  MAIN_MENU,
  MAIN_MENU_LEVEL_TOGGLE,
  MAIN_MENU_LEVEL_CLOSE,
  MAIN_MENU_LEVEL_OPEN,
  MAIN_MENU_OPEN,
  MAIN_MENU_CLOSE,
  MAIN_MENU_TOGGLE,
  ToggleMenuAction,
  MainMenuAction
} from './actions';
import { HISTORY_LOCATION_CHANGED } from 'store/history/actions';
import { UPDATE_CURRENT_BREAKPOINT } from 'store/responsive/actions';
import {
  UPDATE_WEB_CATALOG,
  UpdateWebCatalogAction,
  UPDATE_CURRENT_PAGE,
  UpdateCurrentPageAction,
  SET_PAGELOADINGSTATUS,
  SetPageStatusAction
} from 'components/Pagelayout/actions';
import { LoadingStatus } from 'models/LoadingStatus';

export const initialState: IMainMenu = {
  isOpen: false,
  items: [],
  open: [],
  webCatalog: '',
  hash: ''
};

const reducer = {
  [MAIN_MENU]: (state: IMainMenu, { menu }: MainMenuAction) => {
    return { ...state, items: menu };
  },
  [MAIN_MENU_LEVEL_OPEN]: (state: IMainMenu, action: ToggleMenuAction) => {
    return { ...state, open: [...action.parents, action.target] };
  },
  [MAIN_MENU_LEVEL_CLOSE]: (state: IMainMenu, action: ToggleMenuAction) => {
    return { ...state, open: action.parents };
  },
  [MAIN_MENU_LEVEL_TOGGLE]: (state: IMainMenu, action: ToggleMenuAction) => {
    return {
      ...state,
      open: state.open.includes(action.target)
        ? state.open.slice(
            0,
            state.open.findIndex(i => i === action.target)
          )
        : [...action.parents, action.target]
    };
  },
  [MAIN_MENU_OPEN]: (state: IMainMenu) => {
    return state.isOpen ? state : { ...state, isOpen: true };
  },
  [MAIN_MENU_CLOSE]: (state: IMainMenu) => {
    return !state.isOpen ? state : { ...state, isOpen: false, open: [] };
  },
  [MAIN_MENU_TOGGLE]: (state: IMainMenu) => {
    return { ...state, isOpen: !state.isOpen, open: !state.isOpen ? [] : state.open };
  },
  [HISTORY_LOCATION_CHANGED]: (state: IMainMenu) => {
    return { ...state, isOpen: false, open: [] };
  },
  [SET_PAGELOADINGSTATUS]: (state: IMainMenu, action: SetPageStatusAction) => {
    if (action.status === LoadingStatus.Loading) {
      return { ...state, isOpen: false };
    }
    return state;
  },
  [UPDATE_CURRENT_BREAKPOINT]: (state: IMainMenu) => {
    return { ...state, isOpen: false, open: [] };
  },
  [UPDATE_CURRENT_PAGE]: (state: IMainMenu, { newPage }: UpdateCurrentPageAction) => {
    const webCatalog = newPage ? newPage.webCatalog : state.webCatalog;
    return {
      ...state,
      webCatalog
    };
  },

  // TODO: Remove this when possible
  [UPDATE_WEB_CATALOG]: (state: IMainMenu, { webCatalog }: UpdateWebCatalogAction) => {
    return { ...state, webCatalog };
  }
};

export default createReducer(initialState, reducer);
